import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	type?: 'action' | 'danger' | 'warning'
}

export const IconBackground = styled.div<Props>`
	height: 42px;
	width: 42px;
	border-radius: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	background-color: ${({ type = 'action', theme }) => {
		switch (type) {
			case 'danger':
				return theme.color.danger
			case 'warning':
				return theme.color.warning
			case 'action':
			default:
				return theme.color.action
		}
	}};
	color: ${helpers.color.actionLabel};
`
